import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.fill.js";
import "core-js/modules/es.number.constructor.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
var _hoisted_1 = ["title"];
import star from '@/assets/space/score-star.svg';
import moon from '@/assets/space/score-moon.svg';
import sun from '@/assets/space/score-sun.svg';
export default {
  __name: 'RateLevel',
  props: {
    // 总的星星数
    stars: {
      type: Number,
      default: 0
    },
    // 兑换步长
    step: {
      type: Number,
      default: 3
    }
  },
  setup: function setup(__props) {
    /**
     * 评分等级组件
     */
    var props = __props;
    var iconEnum = {
      'score-star': star,
      'score-moon': moon,
      'score-sun': sun
    };

    // 计算图标显示数组
    var calculateIcons = function calculateIcons() {
      var starCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var suns = Math.floor(starCount / Math.pow(props.step, 2)); // 计算太阳的数量
      var sunsIcons = Array(suns).fill('score-sun');
      var remainingScoreAfterSuns = starCount % Math.pow(props.step, 2); // 剩余分数

      var moons = Math.floor(remainingScoreAfterSuns / props.step); // 计算月亮的数量
      var moonsIcons = Array(moons).fill('score-moon');
      var remainingScoreAfterMoons = remainingScoreAfterSuns % props.step; // 剩余分数

      var stars = remainingScoreAfterMoons; // 剩余分数即星星的数量
      var starsIcons = Array(stars).fill('score-star');
      return [].concat(_toConsumableArray(sunsIcons), _toConsumableArray(moonsIcons), _toConsumableArray(starsIcons));
    };
    return function (_ctx, _cache) {
      var _component_t_image = _resolveComponent("t-image");
      var _component_t_tooltip = _resolveComponent("t-tooltip");
      return _openBlock(), _createBlock(_component_t_tooltip, {
        class: "placement top center",
        content: "自主管理个人晋级等级",
        placement: "top",
        "overlay-style": {
          width: '260px'
        },
        "show-arrow": ""
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("ul", {
            class: "rate-level",
            title: "\u661F\u661F\u6570\uFF1A".concat(props.stars)
          }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calculateIcons(props.stars), function (icon, index) {
            return _openBlock(), _createElementBlock("li", {
              key: icon + index,
              class: _normalizeClass(icon)
            }, [_createVNode(_component_t_image, {
              class: "image-icon",
              src: iconEnum[icon]
            }, null, 8, ["src"])], 2);
          }), 128))], 8, _hoisted_1)];
        }),
        _: 1
      });
    };
  }
};